import { IRolesTenantsMappings } from 'types/authorization';

import { ICommon } from './common';

export enum AccessKeyType {
	access = 'accessKeys',
	management = 'managementKeys'
}

export enum AccessKeyStatus {
	active = 'active',
	inactive = 'inactive'
}

export enum AccessKeyExpiration {
	never = 0,
	thirty = 30,
	sixty = 60,
	ninety = 90
}

export interface IAccessKey extends ICommon, IRolesTenantsMappings {
	name: string;
	hash: string;
	expireTime: number;
	status: AccessKeyStatus;
	project: string;
	createdBy: string;
	permittedProjects?: string[];
}

export interface IGenerateAccessKey extends IRolesTenantsMappings {
	name: string;
	expireTime: number;
	permittedProjects?: string[];
	allProjects?: boolean;
}
export interface IGeneratedAccessKey {
	key: IAccessKey;
	cleartext: string;
}
